import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import styles from '../Pages/NewQuote.module.css';
import { useNavigate, useParams } from 'react-router-dom'; // Import useParams

const EditQuote = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Retrieve id from URL params
  const authorInputRef = useRef();
  const quoteInputRef = useRef();

  const [quote, setQuote] = useState({ author: '', text: '' });

  useEffect(() => {
    async function fetchQuote() {
      try {
        const res = await axios.get(`https://quotes-app-qrwa.onrender.com/quotes/${id}`); // Use id from useParams
        const { author, text } = res.data;
        setQuote({ author, text });
      } catch (error) {
        console.error('Error fetching quote:', error);
      }
    }
    fetchQuote();
  }, [id]); // Include id in dependency array

  const updateQuoteHandler = async (e) => {
    e.preventDefault();

    const updatedAuthor = authorInputRef.current.value;
    const updatedText = quoteInputRef.current.value;

    try {
      await axios.patch(`https://quotes-app-qrwa.onrender.com/quotes/${id}`, {
        author: updatedAuthor,
        text: updatedText
      });
      navigate(`/quotes/${id}`);
    } catch (error) {
      console.error('Error updating quote:', error);
    }
  };

  return (
    <form onSubmit={updateQuoteHandler} className={styles['new-quote-form']}>
      <h1>EDIT QUOTE</h1>

      <div>
        <label htmlFor="author">Author</label>
        <input type="text" id="author" placeholder="Author Name" ref={authorInputRef} defaultValue={quote.author} />
      </div>

      <div>
        <label htmlFor="quote">Quote</label>
        <textarea cols={10} rows={5} placeholder="Write the quotes here ..." ref={quoteInputRef} defaultValue={quote.text}></textarea>
      </div>

      <button type="submit">Update</button>
    </form>
  );
};

export default EditQuote;
